import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

const seoRoutes = {
  'how-it-works': 'saadan-virker-handyhand',
  'privacy-policy': 'privatlivspolitik',
  guidelines: 'retningslinjer',
  press: 'presse',
  'terms-and-agreements': 'forretningsbetingelser',
  'about-us': 'hvemervi',
  skadegodtgoerelse: 'skadegodtgoerelse',
  'calculate-income': 'beregn-indtaegt',
  app: 'app',
  categories: 'kategorier',
  blog: 'blog',
  'price-guides': 'index/pris-guides-estimat-overslag',
  landing: '',
} as const;

type SeoRoutes = keyof typeof seoRoutes;

interface RouteOptions {
  target?: '_blank' | '_self' | '_parent' | '_top';
}

const defaultRouteOptions: RouteOptions = {
  target: '_self',
} as const;

/**
 * This service is responsible for linking to the Handyhand SEO pages.
 *
 * All links and redirects to the handyhand main domain should be handled by this service.
 */
@Injectable({
  providedIn: 'root',
})
export class ExternalLinksService {
  readonly handyhandSeoBaseHref = environment.seoBaseHref;

  constructor() {}

  goToPage(route: SeoRoutes, options = defaultRouteOptions) {
    const url = `${this.handyhandSeoBaseHref}/${seoRoutes[route]}`;
    window.open(url, options?.target || '_self');
  }

  getPageUrl(route: SeoRoutes) {
    return `${this.handyhandSeoBaseHref}/${seoRoutes[route]}`;
  }
}
